import { UndoOutlined } from "@ant-design/icons";
import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import {
  BUTTON_KEYS,
  BUTTON_TYPE_VALUES,
  BUTTON_TYPE,
} from "@/constants/Button";
import { ButtonsPropTypes } from "@/propTypes/Button.type";

const RestoreButton = ({
  label,
  loading,
  type = BUTTON_TYPE.DEFAULT,
  onClick,
  buttonProps = {},
}) => {
  const { t } = useTranslation();

  return (
    <Button
      icon={<UndoOutlined />}
      key={BUTTON_KEYS.RESTORE}
      loading={loading}
      role="button"
      size="small"
      type={type}
      onClick={onClick}
      {...buttonProps}
    >
      {label ?? t("global:restore")}
    </Button>
  );
};

RestoreButton.propTypes = {
  label: PropTypes.node,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(BUTTON_TYPE_VALUES),
  onClick: PropTypes.func,
  buttonProps: ButtonsPropTypes,
};

export default RestoreButton;
